import { apiUrl } from "../utils/api";
import { apiBasePath } from "./services/BaseUrl";

// Get evaluation criteria
export const evaluationCriteriaApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getEvaluationCriteria: build.query({
      query: () => ({
        url: apiUrl.evaluationCriteria,
        method: 'GET',
      }),
      providesTags: ['EvaluationCriteria'],
    }),
    updateEvaluationCriteria: build.mutation({
      query: ({ id, ...data }) => ({
        url: `${apiUrl.evaluationCriteria}${id ? `${id}/` : ''}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['EvaluationCriteria'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetEvaluationCriteriaQuery,
  useUpdateEvaluationCriteriaMutation,
} = evaluationCriteriaApi;
